import { createSlice } from "@reduxjs/toolkit";
import { deletePurchaseOrder, fetchPurchaseOrderRecord } from "./PurchaseOrderRecordThunk";

const initialState = {
  list: [],
  loading: false,
  accessType: "WRITE", // later could be dynamic
  filters: {
    filterType: "All",
    recordType: "without item",
    fromDate: null, // 👈 separate field
    toDate: null,
  },
};

const purchaseOrderRecordSlice = createSlice({
  name: "purchaseOrderRecord",
  initialState,
  reducers: {
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
    setPurchaseOrderId(state, action) {
      state.pur_o_id = action.payload;
    },
    setEditModeData(state, action) {
      const data = action.payload;

      if (data.supplierInfo) state.supplierInfo = data.supplierInfo;
      if (data.itemCart) state.itemCart = data.itemCart;
      if (data.footerValues) state.footerValues = data.footerValues;
      if (data.narration) state.narration = data.narration;
      if (data.voucherNumber) state.voucherNumber = data.voucherNumber;
      if (data.entryDate) state.entryDate = data.entryDate;
      if (data.dueDate) state.dueDate = data.dueDate;
      if (data.tagFieldId) state.tagFieldId = data.tagFieldId;
      if (data.pur_o_id) state.pur_o_id = data.pur_o_id;
      if (data.paymentTerm) state.paymentTerm = data.paymentTerm;
      if (data.taxMode) state.taxMode = data.taxMode;

    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPurchaseOrderRecord.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchPurchaseOrderRecord.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload;
      })
      .addCase(fetchPurchaseOrderRecord.rejected, (state) => {
        state.loading = false;
      })

      // ✅ DELETE PURCHASE ORDER
      .addCase(deletePurchaseOrder.pending, (state) => {
        state.loading = true;
      })
      .addCase(deletePurchaseOrder.fulfilled, (state, action) => {
        state.loading = false;
        const deletedId = action.payload;
        state.list = state.list.filter(row => row.id !== deletedId);
      })
      .addCase(deletePurchaseOrder.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const { setFilters } = purchaseOrderRecordSlice.actions;
export default purchaseOrderRecordSlice.reducer;
